import Loader from 'components/Helpers/Loader'
import React from 'react'

export default ({ url, size }) => {
  if (!url) return <Loader />
  if (localStorage.getItem('cookies') === 'accepted')
    return <iframe title="googleMap" className={`map ${size}`} src={url} />
  return false
}
